import { makeStyles } from 'makeStyles';
import { LIST_HOVER, MAIN } from 'theme/colors';

export const useStyles = makeStyles()((theme) => ({
  danger: { color: 'red' },
  warning: { color: 'orange' },
  success: { color: 'green' },
  primary: { color: 'blue' },
  icon: { marginRight: '1em', minWidth: 30, flexShrink: 0 },
  label: {
    verticalAlign: 'middle',
    '& .MuiTypography-root': {
      fontWeight: 'normal',
      fontSize: '15px',
      lineHeight: 1.5,
      marginLeft: 5,
      marginTop: 2,
    },
  },
  '&.Mui-selected': {
    outline: 'none',
  },
  '&:hover': {
    outline: 'none',
  },
  checkbox: {
    '&.Mui-checked': {
      color: `${MAIN}!important`,
    },
    width: '30px',
    padding: '0px 0px 0px 0px',
    '&:hover': {
      backgroundColor: 'transparent!important',
    },
    '& svg': {
      width: '24px',
      height: '24px',
    },
  },
  popoverPaper: {
    border: `solid 1px ${theme.palette.grey['200']}`,
    boxShadow: '0 10px 25px 0 rgba(0, 0, 0, 0.12)',
    backgroundColor: '#fff',
    '& .MuiList-root': {
      padding: '12px 0px',
    },
  },
  popoverCheckboxes: {
    '& .MuiListItem-root': {
      paddingTop: 5,
      paddingBottom: 5,
    },

    '& .MuiListItem-button:hover': {
      backgroundColor: `${LIST_HOVER}`,
    },
  },
  popoverIcons: {
    '& .MuiListItem-root': {
      padding: '6px 18px',
      fontSize: 15,
    },
    '& .MuiListItem-button:hover': {
      backgroundColor: `${LIST_HOVER}`,
    },
    '& svg': {
      display: 'flex',
      alignSelf: 'center',
      width: '18px',
      height: '18px',
    },
  },
}));
